const ApplicationType = {
    customer: 1,
    installer: 2,
    admin: 3,
} as const;

const AddressType = {
    billing: 1,
    shipping: 2,
} as const;

const Status = {
    inactive: 0,
    active: 1,
    deleted: 2,
} as const;

const Theme = {
    auto: 0,
    light: 1,
    dark: 2,
} as const;

const AppVersionPolicy = {
    forceUpdate: 1,
    flexibleUpdate: 2,
} as const;

const UserPermissionActionsPositions = {
    view: 1,
    create: 2,
    edit: 3,
    delete: 4,
    // Update below two if you get new actions
    new: 5,
    others: 6,
} as const;

export { ApplicationType, AddressType, Status, AppVersionPolicy, Theme, UserPermissionActionsPositions };
